import { StyledTable } from '@/Components/Elements/StyledComponents/Tables';
import React, { Component } from 'react'
import LoadingDefault from '../../Elements/Loading/LoadingDefault'

import { Alert, Box, Paper, Stack, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material';import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
    faPlus,
    faCheck,
    faMinus,
    faClock,
} from '@fortawesome/pro-duotone-svg-icons'

import VerzoekToewijzingForm from './VerzoekToewijzingForm'
import {
    CompactButton,
    StyledButton,
} from '@/Components/Elements/StyledComponents/Buttons'

class VerzoekToewijzingen extends Component {
    constructor(props) {
        super(props)

        this.state = {
            errorData: null,
            loading: false,
            dossierId: null,
            items: [],
            pager: {},
        }
    }

    addClient(dossierId) {
        // /module/ijwiwmo/client/add
        const api = this.props.kedo.api()
        this.setState({ loading: true })
        api.post('/module/ijwiwmo/client/add/' + this.props.dossierId)
            .then((response) => {
                window.location.reload()
            })
            .catch((err) => {
                alert('Fout bij aanmaken cliënt')
            })
    }

    fetchData() {
        if (this.state.loading) {
            return
        }
        const api = this.props.kedo.api()
        this.setState({ loading: true })
        api.get('/module/ijwiwmo/vot/' + this.props.dossierId)
            .then((response) => {
                this.setState({
                    loading: false,
                    errorData: null,
                    items: response.data.results,
                    pager: response.data.pager,
                    dossierId: this.props.dossierId,
                })
            })
            .catch((err) => {
                if (err.response.status === 400) {
                    this.setState({
                        loading: false,
                        errorData: err.response.data,
                    })
                } else {
                    this.setState({
                        errorData: null,
                        loading: false,
                    })
                }
            })
    }

    componentDidMount() {
        this.fetchData()
    }

    render() {
        const kedo = this.props.kedo

        if (this.state.loading) {
            return <LoadingDefault />
        }

        const errorData = this.state.errorData
        if (errorData) {
            if (
                errorData.errors?.hasBirthDate &&
                errorData.errors?.hasLastname &&
                errorData.errors?.hasGender
            ) {
                return (
                    <Alert severity="info">
                        <p>
                            De desbetreffende persoon is niet bekend voor het
                            berichtenverkeer, geef hier onder akkoord om deze
                            persoon door te sturen.
                        </p>
                        <Stack direction="row" spacing={1}>
                            <StyledButton
                                variant="contained"
                                color="primary"
                                onClick={() => this.addClient()}
                            >
                                {kedo.t('Create')}
                            </StyledButton>
                            <StyledButton
                                variant="outlined"
                                color="secondary"
                                invert
                            >
                                {kedo.t('Cancel')}
                            </StyledButton>
                        </Stack>
                    </Alert>
                )
            }

            return (
                <Alert severity="info">
                    Er missen gegevens (
                    {!errorData.errors?.hasBirthDate ? 'geboortedatum ' : ''}
                    {!errorData.errors?.hasLastname ? 'achternaam ' : ''}
                    {!errorData.errors?.hasGender ? 'geslacht ' : ''}) waardoor
                    er geen berichten voor het berichtenverkeer opgehaald kunnen
                    worden. Vul de ontbrekende gegevens in.
                </Alert>
            )
        }

        return (
            <div>
                {this.state.add ? (
                    <VerzoekToewijzingForm
                        kedo={kedo}
                        onClose={(refresh) =>
                            this.setState({ add: null }, () => {
                                if (refresh === true) {
                                    this.fetchData()
                                }
                            })
                        }
                        dossierId={this.props.dossierId}
                    />
                ) : null}
                <Stack direction="row" justifyContent="flex-end" mb={2}>
                    <CompactButton onClick={() => this.setState({ add: true })}>
                        <FontAwesomeIcon icon={faPlus} />
                    </CompactButton>
                </Stack>
                <TableContainer component={Paper}>
                    <StyledTable size="small" striped>
                        <TableHead>
                            <TableRow
                                sx={{
                                    '& .MuiTableCell-head, th': {
                                        textAlign: 'left',
                                        fontWeight: 'bold',
                                    },
                                }}
                            >
                                <TableCell>#</TableCell>
                                <TableCell>Gemeente</TableCell>
                                <TableCell>Ingangsdatum</TableCell>
                                <TableCell>Product</TableCell>
                                <TableCell>Eenheid</TableCell>
                                <TableCell>Volume</TableCell>
                                <TableCell>Status</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody
                            sx={{
                            }}
                        >
                            {this.state.items.map((item, index) => (
                                <TableRow
                                    key={item.id}
                                    sx={{
                                        bgcolor:
                                            index % 2 === 0
                                                ? 'action.hover'
                                                : 'background.paper',
                                    }}
                                >
                                    <TableCell>{item.id}</TableCell>
                                    <TableCell>{item.gemeentenaam}</TableCell>
                                    <TableCell>
                                        {kedo
                                            .utils()
                                            .dateFormat(
                                                item.toewijzing_ingangsdatum,
                                                'YYYY-MM-DD'
                                            )}
                                    </TableCell>
                                    <TableCell>
                                        {item.prod_cat_naam} {item.product_code}
                                    </TableCell>
                                    <TableCell>{item.eenheid_naam}</TableCell>
                                    <TableCell>{item.volume}</TableCell>
                                    <TableCell>
                                        {item.processed?.length > 0 ? (
                                            <Stack direction="row" spacing={1}>
                                                {item.statussen.map(
                                                    (status) => {
                                                        const faulty =
                                                            status.retour_codes?.some(
                                                                (retour) =>
                                                                    retour.faulty
                                                            )

                                                        if (
                                                            status.retour_codes
                                                                ?.length > 0
                                                        ) {
                                                            return (
                                                                <Stack
                                                                    key={`status-${status.code}`}
                                                                    direction="row"
                                                                    spacing={1}
                                                                >
                                                                    {faulty ? (
                                                                        <CompactButton
                                                                            disabled
                                                                            color="error"
                                                                            size="small"
                                                                            dense
                                                                            invert
                                                                        >
                                                                            <FontAwesomeIcon
                                                                                icon={
                                                                                    faMinus
                                                                                }
                                                                            />
                                                                        </CompactButton>
                                                                    ) : (
                                                                        <CompactButton
                                                                            disabled
                                                                            color="success"
                                                                            size="small"
                                                                            dense
                                                                            invert
                                                                        >
                                                                            <FontAwesomeIcon
                                                                                icon={
                                                                                    faCheck
                                                                                }
                                                                            />
                                                                        </CompactButton>
                                                                    )}

                                                                    <Box>
                                                                        <Typography variant="body2">
                                                                            {
                                                                                status.aangemaakt_op
                                                                            }{' '}
                                                                            {
                                                                                status.status
                                                                            }
                                                                        </Typography>

                                                                        {status.retour_codes.map(
                                                                            (
                                                                                retour
                                                                            ) => (
                                                                                <Typography
                                                                                    key={`retour-${retour.code}`}
                                                                                    variant="caption"
                                                                                    display="block"
                                                                                >
                                                                                    {
                                                                                        retour.code
                                                                                    }

                                                                                    :{' '}
                                                                                    {
                                                                                        retour.msg
                                                                                    }
                                                                                </Typography>
                                                                            )
                                                                        )}

                                                                        <FontAwesomeIcon
                                                                            icon={
                                                                                faMinus
                                                                            }
                                                                        />
                                                                    </Box>
                                                                </Stack>
                                                            )
                                                        }

                                                        return (
                                                            <CompactButton
                                                                key={`rc-${status?.code}`}
                                                                disabled
                                                                color="success"
                                                                dense
                                                                invert
                                                                size="small"
                                                            >
                                                                <FontAwesomeIcon
                                                                    icon={
                                                                        faCheck
                                                                    }
                                                                />
                                                            </CompactButton>
                                                        )
                                                    }
                                                )}
                                            </Stack>
                                        ) : (
                                            item.state &&
                                            item.state === 3 && (
                                                <Typography variant="body2">
                                                    In wachtrij{' '}
                                                    <FontAwesomeIcon
                                                        icon={faClock}
                                                    />
                                                </Typography>
                                            )
                                        )}
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </StyledTable>
                </TableContainer>
            </div>
        )
    }
}

export default VerzoekToewijzingen
